import type { ProjectStatus } from "@/mocks/admin/projects";

const map: Record<ProjectStatus, { label: string; bg: string; text: string; dot: string }> = {
  "in-progress": {
    label: "In Progress",
    bg: "bg-brand-50",
    text: "text-brand-700",
    dot: "bg-brand-500",
  },
  scheduled: {
    label: "Scheduled",
    bg: "bg-amber-50",
    text: "text-amber-700",
    dot: "bg-amber-500",
  },
  completed: {
    label: "Completed",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    dot: "bg-emerald-500",
  },
  "on-hold": {
    label: "On Hold",
    bg: "bg-ink-100",
    text: "text-ink-700",
    dot: "bg-ink-500",
  },
  cancelled: {
    label: "Cancelled",
    bg: "bg-rose-50",
    text: "text-rose-700",
    dot: "bg-rose-500",
  },
};

type Props = {
  status: ProjectStatus;
  size?: "sm" | "md";
};

export default function StatusBadge({ status, size = "sm" }: Props) {
  const s = map[status];
  const sizing =
    size === "md" ? "px-3 py-1 text-xs gap-2" : "px-2 py-0.5 text-[10px] gap-1.5";
  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${s.bg} ${s.text} ${sizing} whitespace-nowrap`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`}></span>
      {s.label}
    </span>
  );
}